export const FIELD_ID = {
  calendarEvent: {
    injury: 1122614,
    calendar: 31488998,
  },
}
